export default __webpack_public_path__ + "locales/pt-BR/DeleteDialog.json?hash=1f31b1fd317e0bf945dd8c7a5718f1f8";